import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { withStyles } from '@material-ui/core/styles'
import CardHeader from '@material-ui/core/CardHeader'
import Avatar from '@material-ui/core/Avatar'
import CommentIcon from '@material-ui/icons/Comment'
import Menu from '@material-ui/core/Menu'
import MenuItem from '@material-ui/core/MenuItem'
import Typography from '@material-ui/core/Typography'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import IconButton from '@material-ui/core/IconButton'
import CloseIcon from '@material-ui/icons/ChevronLeft'
import Tooltip from './Tooltip'
import { makeGetTimesliderDatetime } from '../selectors/timesliderDatetimeSelector'
import format from 'date-fns/format'
// import getIcon from '../utility/getIcon'
import { SERVICE_ICONS } from '../config/icons'
import { LOGOS } from '../config/logos'

const styles = theme => ({
  title: {
    minWidth: '10rem'
  },
  icon: {
    paddingRight: '0.5rem'
  }
})

class ServiceCardHeader extends PureComponent {
  state = {
    anchor: null,
    menuOpen: false
  }

  handleMenuClosed = object => event => {
    const { serviceCardChanged } = this.props
    if (object) {
      serviceCardChanged(object)
    }

    this.setState({ menuOpen: false })
  }

  handleMenuOpened = event => {
    const { currentTarget } = event

    this.setState({ menuOpen: true, anchor: currentTarget })
  }

  render () {
    const { classes, service, services, datetime, handleClose } = this.props
    const { anchor, menuOpen } = this.state
    // const Icon = service.iconComponent ? SERVICE_ICONS[service.iconComponent] : CommentIcon
    const Icon = service.iconComponent && SERVICE_ICONS[service.iconComponent] ? SERVICE_ICONS[service.iconComponent] : CommentIcon
    if (Object.keys(SERVICE_ICONS).length === 0) {
      console.log(service.iconComponent)
      console.log(SERVICE_ICONS)
    }

    
    return [
      <CardHeader
        key={'serviceCardHeader'}
        action={
          <Tooltip id={'closeDrawer'} title={'close'}>
            <IconButton>
              <CloseIcon onClick={handleClose} />
            </IconButton>
          </Tooltip>
        }
      avatar={
          <div data-tour='service-selector' style={{ display: 'flex'}}>
            <Tooltip
            id={'serviceSelector'}
            title={'select service'}
            justify='top'
          >
            <Avatar className={'Avatar'} onClick={this.handleMenuOpened}>
              <Icon />
            </Avatar>
          </Tooltip>
          </div>
        }
      title={service.logo ? LOGOS[service.logo] : <div>{service.label}</div> || service.name}
        subheader={service.disableMainDate ? null : datetime}
      />,
      <Menu
        key={'serviceMenu'}
        open={menuOpen}
        anchorEl={anchor}
        onClose={this.handleMenuClosed}
      >
        {services.map((item, index) => {
          const Icon = item.iconComponent ? SERVICE_ICONS[item.iconComponent] : null
          return (
            <MenuItem
              key={index}
              value={item.name}
              onClick={this.handleMenuClosed(item)}
            >
              <ListItemIcon className={classes.icon}>
                <IconButton aria-label='Comments'>
                  {Icon ? <Icon /> : <CommentIcon />}
                </IconButton>
              </ListItemIcon>
              <Typography type='caption'>{item.label || item.name}</Typography>
            </MenuItem>
          )
        })}
      </Menu>
    ]
  }
}

const makeMapStateToProps = () => {
  const getTimesliderDatetime = makeGetTimesliderDatetime()

  const mapStateToProps = state => {
    return {
      datetime: getTimesliderDatetime(state, value =>
        format(value, 'do MMMM YYYY')
      )
    }
  }

  return mapStateToProps
}

export default connect(makeMapStateToProps(), null)(
  withStyles(styles)(ServiceCardHeader)
)



// WEBPACK FOOTER //
// ./src/components/ServiceCardHeader.js